import { ExamGetForm } from "../exam/ExamListForm";

export default class CandidateMRepeatCreateForm extends ExamGetForm {
  candidateIdList: number[] = [];
  sendMessage: any = 0;
}

// 候选人列表打通，批量重面参数
export class RepeatMCreate {
  companyId = 0;
  candidateIdList: number[] = [];
  sendMessage: any = 0;
}
